@use 'styles/functions/rem' as *;

.horizontalContainer {
    display: flex;
    flex-direction: row;
    gap: rem(5px);
    width: 100%;
}
